import React from 'react';
import style from '../../assets/styles/RequestListToBePrepared.module.scss';
import { GlobalContext } from '../../GlobalContext';
import PaymentMethod from '../Payment/PaymentMethod';
import RecipeModal from './RecipeModal';
import DefaultComumMessage from '../Messages/DefaultComumMessage';
import MessagePromotions from '../Promotions/MessagePromotions';
import ButtonCustomerProfile from '../Promotions/ButtonCustomerProfile';
import { firstNameClient } from '../../Helpers/Helpers.js';

const getTableNumber = (order) => {
  if (order?.tableNumber !== undefined && order?.tableNumber !== null && String(order.tableNumber).trim() !== '') {
    return String(order.tableNumber).trim();
  }
  if (order?.mesa !== undefined && order?.mesa !== null && String(order.mesa).trim() !== '') {
    return String(order.mesa).trim();
  }
  return null;
};

const OrderCard = React.memo(({
  orderItem,
  isGroupedTable = false,
  getStatusAndColor,
  warningsEnabled,
  toggleRequest,
  openRequests,
  dismissWaiterCall,
  dismissPaymentCall,
  handlePaymentMethodChange,
  payingOrders,
  setSelectedItemToPay,
  setShowPaymentBlockedPopup,
  changeStatusPaid,
  registeredUserIds,
  selectedPromotion,
  handleSelectChange,
  promotions,
  openShowModal,
  canCancelOrders,
  handleFinishEditFromList,
  handleEditOrder,
  handleReleaseEditFromList,
  getPostpaidButtonState,
  handleWaiterDelivery,
  isOrderFullyFinished,
  openFinalizarModal,
  openPrintScreen,
  ShowDefaultMessage,
  selectedRequestId,
  setShowDefaultMessage,
  handleDeleteRequest,
  messagePromotionPopup,
  textPromotion,
  AddPromotion,
  setMessagePromotionPopup,
  addEditBenefitedClient,
  recipeModal,
  setRecipeModal,
  setRefusalModalData,
  handleRequestItemCancellation,
  descontFinalPrice,
  usersMap,
}) => {
  const global = React.useContext(GlobalContext);

          const { status, color } = getStatusAndColor(orderItem);
          const isPosPagamento = !!(orderItem.tableNumber || orderItem.mesa);
          const hasWaiterCalledAndConfirmed = orderItem.paymentCall && orderItem.paymentCall.active === false;
          const isPaymentDisabled = Boolean(warningsEnabled && isPosPagamento && !hasWaiterCalledAndConfirmed);
          const tableDisplay = getTableNumber(orderItem);

          // Status de alertas e pendências visuais (não dependem do checkbox de popups)
          const isWaiterCallPending = Boolean(orderItem.waiterCall && orderItem.waiterCall.active === true);
          const isBillCallActive = Boolean(orderItem.paymentCall && orderItem.paymentCall.active === true);
          const isBillPending = Boolean(orderItem.paymentCall && (!orderItem.paymentDone || !orderItem.orderDelivered));
          const isDeliveryPending = Boolean(orderItem.request && orderItem.request.some((req) => req.pronto && !req.entregue));

          let orderBlinkClass = '';
          if (isWaiterCallPending) {
            orderBlinkClass = style.blinkingWaiterCallCard;
          } else if (isBillCallActive) {
            orderBlinkClass = style.blinkingPaymentCard;
          } else if (isDeliveryPending) {
            orderBlinkClass = style.blinkingDeliveryCard;
          }

          return (
            <div
              className={`${style.containerRequestListToBePrepared} ${orderBlinkClass}`}
              key={orderItem.id}
              style={orderBlinkClass ? {} : { border: `solid 2px ${color}` }}
            >
              <button
                onClick={() => toggleRequest(orderItem.id)}
                className={style.btnToggle}
              >
                {openRequests[orderItem.id] ? 'Recolher' : 'Expandir'}
              </button>
              {!openRequests[orderItem.id] ? (
                <div className={style.requestIdClosed}>
                  <p>Nome: <strong>{firstNameClient(orderItem.name)}</strong></p>
                  {!isGroupedTable && tableDisplay && <p>Mesa: <strong>{tableDisplay}</strong></p>}
                  {orderItem.deliveryAddress && <p style={{ color: 'var(--btn-color)', fontWeight: 'bold' }}>📍 ENTREGA</p>}
                  <p>Pedido: <strong>{orderItem.countRequest}</strong></p>
                  <p>Valor: <strong>R$ {(Number(orderItem.finalPriceRequest) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
                  <p>Status: <strong>{status}</strong></p>
                  {isWaiterCallPending && (
                    <span className={`${style.statusAlertBadge} ${style.waiterCall}`} title="Cliente chamou o garçom!">
                      🔔 Chamou Garçom
                    </span>
                  )}
                  {isBillPending && (
                    <span className={`${style.statusAlertBadge} ${style.payment}`} title="Cliente solicitou a conta!">
                      💰 Pediu a Conta
                    </span>
                  )}
                  {isDeliveryPending && (
                    <span className={`${style.statusAlertBadge} ${style.delivery}`} title="Prato pronto para levar à mesa!">
                      🍽️ Nova Entrega
                    </span>
                  )}
                </div>
              ) : (
                <div className={style.userContainer}>
                  <div className={style.userContainerInfo}>
                    {isWaiterCallPending && (
                      <div className={style.waiterCallAlertBanner}>
                        <p className={style.waiterCallAlertText}>
                          🔔 <strong>Cliente chamou o Garçom!</strong> Atenda a mesa. O alerta para ao recolher este pedido ou clicar ao lado.
                        </p>
                        <button
                          type="button"
                          className={style.btnDismissCall}
                          onClick={() => dismissWaiterCall(orderItem.id)}
                        >
                          ✓ Concluir Chamado
                        </button>
                      </div>
                    )}
                    {isBillCallActive && (
                      <div className={style.waiterCallAlertBanner} style={{ backgroundColor: '#fff7ed', borderColor: '#ea580c' }}>
                        <p className={style.waiterCallAlertText} style={{ color: '#9a3412' }}>
                          💰 <strong>Cliente pediu a conta!</strong> Dirija-se à mesa para receber. O alerta para ao recolher este pedido ou clicar ao lado.
                        </p>
                        <button
                          type="button"
                          className={style.btnDismissCall}
                          style={{ backgroundColor: '#ea580c', color: 'white' }}
                          onClick={() => dismissPaymentCall(orderItem.id)}
                        >
                          ✓ Concluir Chamado
                        </button>
                      </div>
                    )}
                    {!isBillCallActive && isBillPending && (
                      <div style={{
                        backgroundColor: '#fff7ed',
                        border: '2px solid #ea580c',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#9a3412',
                        fontSize: '0.95rem'
                      }}>
                        💰 Cliente pediu a conta nesta mesa! Receba o pagamento e finalize o pedido.
                      </div>
                    )}
                    {isDeliveryPending && (
                      <div style={{
                        backgroundColor: '#fefce8',
                        border: '2px solid #b45309',
                        borderRadius: '8px',
                        padding: '8px 12px',
                        marginBottom: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#92400e',
                        fontSize: '0.95rem'
                      }}>
                        🍽️ Há prato pronto para entrega! Leve à mesa e clique em "NOVA ENTREGA".
                      </div>
                    )}
                    <div className={style.orderHeaderInfo}>
                      <div className={style.orderHeaderRow}>
                        <p>
                          <span>Nome:</span> <strong>{firstNameClient(orderItem.name)}</strong>
                        </p>
                        {!isGroupedTable && tableDisplay && (
                          <p>
                            <span>Mesa:</span> <strong>{tableDisplay}</strong>
                          </p>
                        )}
                      </div>
                      <div className={style.orderHeaderRow}>
                        <p>
                          <span>Pedido:</span> <strong>#{orderItem.countRequest}</strong>
                        </p>
                        <p>
                          <span>Data:</span> {orderItem.dateTime}
                        </p>
                      </div>
                    </div>

                    {orderItem.deliveryAddress && (
                      <div style={{ backgroundColor: '#fff3cd', padding: '10px', borderRadius: '8px', borderLeft: '5px solid #ff9800', marginTop: '10px', marginBottom: '10px' }}>
                        <h4 style={{ margin: '0 0 5px 0', color: '#d32f2f' }}>📍 Endereço de Entrega</h4>
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Logradouro:</strong> {orderItem.deliveryAddress.logradouro}, nº {orderItem.deliveryAddress.numero}
                        </p>
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Bairro:</strong> {orderItem.deliveryAddress.bairro}
                        </p>
                        {orderItem.deliveryAddress.complemento && (
                          <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                            <strong>Complemento:</strong> {orderItem.deliveryAddress.complemento}
                          </p>
                        )}
                        <p style={{ margin: '0', fontSize: '0.9rem', lineHeight: '1.4' }}>
                          <strong>Distância Aproximada:</strong> {orderItem.deliveryAddress.distance > 0 ? `${orderItem.deliveryAddress.distance} km` : 'N/A'}
                        </p>
                        <a 
                          href={`https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(global.establishmentCep || '')}&destination=${encodeURIComponent(orderItem.deliveryAddress.logradouro + ', ' + orderItem.deliveryAddress.numero + ', ' + orderItem.deliveryAddress.bairro + ', ' + orderItem.deliveryAddress.cep)}`} 
                          target="_blank" 
                          rel="noreferrer"
                          style={{ display: 'inline-block', marginTop: '10px', backgroundColor: '#4285F4', color: 'white', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontWeight: 'bold', fontSize: '0.85rem' }}
                        >
                          🗺️ Abrir Rota no Maps
                        </a>
                      </div>
                    )}
                    {orderItem.serviceChargeEnabled && (
                      <h4 style={{ textAlign: 'center', margin: '3px 0', fontSize: '0.9rem', color: 'var(--btn-color)' }}>
                        Taxa de Serviço ({orderItem.serviceChargePercent || 10}%): R${' '}
                        {(Number(orderItem.serviceChargeValue) || 0).toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </h4>
                    )}
                    <h2 className={style.orderFinalPrice} style={{ margin: '4px 0' }}>
                      Valor final R${' '}
                      {(Number(orderItem.finalPriceRequest) || 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </h2>
                    
                    {orderItem.customerFeedback && (
                      <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '8px', borderLeft: '5px solid var(--btn-color)' }}>
                        {orderItem.customerFeedback.service && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', marginBottom: '4px' }}>
                            <span>Avaliação do serviço:</span> {orderItem.customerFeedback.service} / 5
                          </p>
                        )}
                        {orderItem.customerFeedback.product && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', marginBottom: '4px' }}>
                            <span>Avaliação do produto:</span> {orderItem.customerFeedback.product} / 5
                          </p>
                        )}
                        {orderItem.customerFeedback.comment && (
                          <p style={{ fontSize: '0.9rem', textAlign: 'left', fontStyle: 'italic', marginTop: '8px' }}>
                            <span>Comentário:</span> "{orderItem.customerFeedback.comment}"
                          </p>
                        )}
                      </div>
                    )}
                    <div className={style.customerProfileButton}>
                      <ButtonCustomerProfile
                        item={orderItem}
                        request={orderItem.request}
                        descontFinalPrice={descontFinalPrice}
                      />
                    </div>

                    {/* Formas de pagamento */}
                    <div className={style.paymentMethodWrapper}>
                      <PaymentMethod
                        item={orderItem}
                        onPaymentMethodChange={handlePaymentMethodChange}
                        isPaymentDisabled={isPaymentDisabled}
                        onPaymentBlocked={() => {
                          if (warningsEnabled) {
                            setSelectedItemToPay(orderItem);
                            setShowPaymentBlockedPopup(true);
                          }
                        }}
                      />
                    </div>

                    {/* Botão Pagar embaixo das formas de pagamento (visível apenas quando a tela alternar no PDV <= 1000px, conforme retângulo vermelho) */}
                    <div className={style.payButtonWrapper}>
                      <button
                        disabled={
                          payingOrders[orderItem.id] ||
                          global.orderBeingEdited?.id === orderItem.id ||
                          (!isPaymentDisabled && !orderItem.paymentMethod)
                        }
                        className={orderItem.paymentDone ? style.done : style.pendent}
                        onClick={(e) => {
                          if (isPaymentDisabled) {
                            e.preventDefault();
                            if (warningsEnabled) {
                              setSelectedItemToPay(orderItem);
                              setShowPaymentBlockedPopup(true);
                            }
                            return;
                          }
                          changeStatusPaid(orderItem);
                        }}
                        style={{
                          backgroundColor: orderItem.paymentDone ? 'green' : 'red',
                          color: '#ffffff',
                          ...(isPaymentDisabled
                            ? { opacity: 0.5, cursor: 'not-allowed' }
                            : payingOrders[orderItem.id]
                            ? { opacity: 0.7, cursor: 'wait' }
                            : {})
                        }}
                      >
                        {payingOrders[orderItem.id] ? 'Processando...' : 'Pago'}
                      </button>
                    </div>

                    {global.packageTier !== 1 && (() => {
                      const isRegistered = registeredUserIds.has(orderItem.idUser);
                      const hasPromotionAlready = 
                        orderItem.hasAppliedPromotion || 
                        orderItem.appliedPromotion || 
                        (orderItem.request && orderItem.request.some(r => r.promotional));

                      if (!isRegistered) {
                        return (
                          <div className={style.promotionSelect}>
                            <select disabled value="">
                              <option value="">Cliente não registrado</option>
                            </select>
                          </div>
                        );
                      }

                      if (hasPromotionAlready) {
                        return (
                          <div className={style.promotionSelect}>
                            <select disabled value="">
                              <option value="">Promoção Aplicada</option>
                            </select>
                          </div>
                        );
                      }

                      return (
                        <div className={style.promotionSelect}>
                          <select
                            name="selectedPromotion"
                            value={selectedPromotion}
                            onChange={(e) => handleSelectChange(e, orderItem)}
                          >
                            <option value="">Promoções</option>
                            {promotions &&
                              promotions.length > 0 &&
                              promotions.map((promotion, index) => (
                                <option key={index} value={index}>
                                  {promotion.title}
                                </option>
                              ))}
                          </select>
                        </div>
                      );
                    })()}

                    {(() => {
                      const customerUser = orderItem.idUser ? usersMap.get(orderItem.idUser) : null;
                      const availableCredit = customerUser ? parseFloat(customerUser.credit || 0) : 0;

                      if (!orderItem.paymentDone && availableCredit > 0) {
                        return (
                          <div className={style.customerCreditBox} title="Crédito disponível do cliente">
                            <span>Crédito:</span>
                            <strong>
                              R${' '}
                              {availableCredit.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </strong>
                          </div>
                        );
                      }

                      if (orderItem.paymentDone && orderItem.creditUsed > 0) {
                        return (
                          <div className={style.customerCreditBoxPaid} title="Crédito utilizado neste pedido">
                            <span>
                              Crédito Usado: R${' '}
                              {Number(orderItem.creditUsed).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </div>
                        );
                      }

                      return null;
                    })()}
                  </div>

                  {/* Coluna da direita no Desktop normal / Linha horizontal compacta no PDV Móvel (<= 1000px) */}
                  <div className={style.btnStatus}>
                    <button
                      onClick={() => openShowModal(orderItem.id)}
                      className={style.pendent}
                      disabled={global.orderBeingEdited?.id === orderItem.id || !canCancelOrders}
                      title={!canCancelOrders ? "Apenas colaboradores com permissão podem cancelar pedidos" : "Cancelar pedido"}
                      style={!canCancelOrders ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(50%)' } : {}}
                    >
                      Cancelar pedido
                    </button>

                    {localStorage.getItem('pdv') === 'true' && !orderItem.paymentDone && (
                      global.orderBeingEdited?.id === orderItem.id ? (
                        <div style={{ display: 'inline-flex', gap: '4px', flexWrap: 'wrap' }}>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#2e7d32', color: 'white', fontWeight: 'bold' }}
                            onClick={() => handleFinishEditFromList(orderItem)}
                            title="Finalizar edição do pedido e enviar itens"
                          >
                            Finalizar
                          </button>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#ff9800', color: 'white', fontWeight: 'bold' }}
                            onClick={() => {
                              global.setPdvRequest(true);
                              if (window.innerWidth < 1000) {
                                global.setPdvMobileView('menu');
                              }
                            }}
                            title="Continuar editando itens no cardápio"
                          >
                            Continuar
                          </button>
                          <button
                            className={style.pendent}
                            style={{ backgroundColor: '#757575', color: 'white' }}
                            onClick={() => handleReleaseEditFromList()}
                            title="Liberar pedido no PDV"
                          >
                            Liberar
                          </button>
                        </div>
                      ) : (
                        <button
                          className={style.pendent}
                          style={{ backgroundColor: 'orange', color: 'white' }}
                          onClick={() => handleEditOrder(orderItem)}
                        >
                          Editar Pedido
                        </button>
                      )
                    )}

                    {/* Botão Pago Desktop: exibido na coluna da direita no desktop normal (> 1000px), oculto no mobile PDV */}
                    <button
                      disabled={
                        payingOrders[orderItem.id] ||
                        global.orderBeingEdited?.id === orderItem.id ||
                        (!isPaymentDisabled && !orderItem.paymentMethod)
                      }
                      className={`${orderItem.paymentDone ? style.done : style.pendent} ${style.btnPagoDesktop}`}
                      onClick={(e) => {
                        if (isPaymentDisabled) {
                          e.preventDefault();
                          if (warningsEnabled) {
                            setSelectedItemToPay(orderItem);
                            setShowPaymentBlockedPopup(true);
                          }
                          return;
                        }
                        changeStatusPaid(orderItem);
                      }}
                      style={
                        isPaymentDisabled
                          ? { opacity: 0.5, cursor: 'not-allowed' }
                          : payingOrders[orderItem.id]
                          ? { opacity: 0.7, cursor: 'wait' }
                          : {}
                      }
                    >
                      {payingOrders[orderItem.id] ? 'Processando...' : 'Pago'}
                    </button>

                    {(() => {
                      const btnState = getPostpaidButtonState(orderItem);
                      return (
                        <button
                          disabled={orderItem.orderDelivered || global.orderBeingEdited?.id === orderItem.id || btnState.label === 'PRONTO'}
                          className={btnState.className}
                          style={btnState.inlineStyle}
                          onClick={() => handleWaiterDelivery(orderItem)}
                        >
                          {btnState.label}
                        </button>
                      );
                    })()}

                    <button
                      disabled={!orderItem.paymentDone || orderItem.orderDelivered || global.orderBeingEdited?.id === orderItem.id || !isOrderFullyFinished(orderItem)}
                      className={style.pendent}
                      onClick={() => openFinalizarModal(orderItem)}
                    >
                      Finalizar
                    </button>

                    <button
                      disabled={!orderItem.paymentMethod || global.orderBeingEdited?.id === orderItem.id}
                      className={`${style.pendent} ${style.btnFiscalAttributes}`}
                      onClick={() => openPrintScreen(orderItem)}
                    >
                      Nota
                    </button>
                  </div>
                  {/* Modais movidos para fora da grid de botões */}
                  {ShowDefaultMessage && selectedRequestId === orderItem.id && (
                    <DefaultComumMessage
                      msg="Você está prestes a excluir esse pedido"
                      onClose={() => {
                        setShowDefaultMessage(false);
                      }}
                      onConfirm={() =>
                        handleDeleteRequest(selectedRequestId)
                      }
                    />
                  )}

                  {messagePromotionPopup && (
                    <MessagePromotions
                      message={textPromotion}
                      AddPromotion={AddPromotion}
                      setClose={setMessagePromotionPopup}
                      onContinue={addEditBenefitedClient}
                    />
                  )}
                </div>
              )}
              {orderItem.request && openRequests[orderItem.id] && (
                <>
                  {recipeModal.openModal && (
                    <RecipeModal
                      setRecipeModal={setRecipeModal}
                      recipeModal={recipeModal}
                    />
                  )}
                  <div className={style.requestItemsGrid}>
                    {orderItem.request.map((dish, recipeIndex) => {
                      const dishNeedsDelivery = dish.pronto && !dish.entregue;
                      const isPendingInKitchen = !dish.pronto && !dish.entregue;

                      return (
                        <div
                          className={`${style.requestItem} ${dishNeedsDelivery ? style.dishItemNeedsDelivery : ''}`}
                          key={recipeIndex}
                        >
                          <div className={style.dishTopSection}>
                            {/* Alerta de status do prato - com destaque para prato pronto aguardando entrega */}
                            <div className={style.dishStatusAlert}>
                              {dishNeedsDelivery ? (
                                <span
                                  className={style.badgeDeliveryAlert}
                                  title="Prato pronto na cozinha! Levar à mesa"
                                >
                                  🍽️ Levar à Mesa
                                </span>
                              ) : dish.entregue ? (
                                <span className={style.badgeEntregue}>
                                  ✓ Entregue{' '}
                                  {dish.tempo_levado && (
                                    <span className={style.badgeTempo}>
                                      ({dish.tempo_levado.replace(/tempo levado:\s*/i, '').replace(/0\s*min\s*e\s*/i, '').replace(/min e/i, 'm ').replace(/min/i, 'm').replace(/seg/i, 's').trim()})
                                    </span>
                                  )}
                                </span>
                              ) : dish.refusalRequested ? (
                                <span className={style.badgeRefusal}>
                                  {dish.refusalType === 'ajuste' ? '⚠️ Em Ajuste' : '⚠️ Prato Recusado'}
                                </span>
                              ) : (
                                isPendingInKitchen && (
                                  <span className={style.badgePendingKitchen}>
                                    ⏳ Na Cozinha
                                  </span>
                                )
                              )}
                            </div>

                            {/* Nome do prato e tamanho se houver */}
                            <div className={style.dishTitleArea}>
                              <h5 className={style.dishName} title={dish.name}>
                                {dish.name}
                              </h5>
                              {dish.size && (
                                <span className={style.dishSize}>({dish.size})</span>
                              )}
                            </div>

                            {/* Acompanhamentos: somente se houver acompanhamento cadastrado (sem negativa) */}
                            {dish.sideDishes && dish.sideDishes.length > 0 && (
                              <div className={style.sideDishesCompact} title="Acompanhamentos">
                                <span className={style.sideDishesLabel}>Acomp:</span>{' '}
                                {dish.sideDishes.map((side, idx) => (
                                  <span key={idx} className={style.sideDishItem}>
                                    {side.name}
                                    {idx < dish.sideDishes.length - 1 ? ', ' : ''}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>

                          {/* Pequeno botão de cancelar / recusar */}
                          <div className={style.dishCardActions}>
                            {dish.entregue ? (
                              <button
                                type="button"
                                onClick={() =>
                                  setRefusalModalData({
                                    dish: dish,
                                    order: orderItem,
                                    itemIndex:
                                      dish.indexInRequest !== undefined
                                        ? dish.indexInRequest
                                        : recipeIndex,
                                  })
                                }
                                className={style.btnSmallRefusal}
                                disabled={dish.refusalRequested || orderItem.paymentDone}
                                style={{
                                  opacity: dish.refusalRequested || orderItem.paymentDone ? 0.7 : 1,
                                  cursor: dish.refusalRequested || orderItem.paymentDone ? 'not-allowed' : 'pointer',
                                }}
                                title={
                                  dish.refusalRequested
                                    ? 'Aguardando resposta da cozinha'
                                    : 'Recusar ou ajustar prato'
                                }
                              >
                                {dish.refusalRequested ? 'Prato Recusado' : 'Ajustar prato'}
                              </button>
                            ) : (
                              <button
                                type="button"
                                onClick={() =>
                                  handleRequestItemCancellation(
                                    orderItem,
                                    dish.indexInRequest !== undefined
                                      ? dish.indexInRequest
                                      : recipeIndex
                                  )
                                }
                                className={style.btnSmallCancel}
                                disabled={
                                  !canCancelOrders ||
                                  dish.pronto ||
                                  dish.cancelRequested ||
                                  orderItem.paymentDone
                                }
                                title={
                                  !canCancelOrders
                                    ? 'Apenas colaboradores com permissão podem cancelar itens'
                                    : dish.cancelRequested
                                    ? 'Cancelamento Solicitado'
                                    : 'Cancelar Item'
                                }
                                style={
                                  !canCancelOrders
                                    ? { opacity: 0.5, cursor: 'not-allowed', filter: 'grayscale(50%)' }
                                    : {}
                                }
                              >
                                {dish.cancelRequested ? 'Cancelamento Solicitado' : 'Cancelar Item'}
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          );
});

export default OrderCard;
